import { memo } from "react";
import { Container } from "./styles";
import { SpacerProps } from "./props.type";

const Spacer = (props: SpacerProps) => {
  return <Container {...props} />;
};

export default memo(Spacer);
